const about = {
    eyebrow: 'About',
    title: 'Engineer, now building with AI',
    summary:
        'I am an AI Engineer at Pentera, building production LLM agents, RAG systems and the AWS infrastructure that runs them. I came to it from five years of full-stack product engineering, and I still like the parts that are not the model — orchestration, retrieval, evaluation, cost control and the infrastructure that keeps an agent dependable in production.',
    getMyResume: 'Download résumé',
    experience: 'Experience',
    skills: 'Skills & tools',
    education: 'Education',
    beyondWork: 'Beyond work',
    factRole: 'Role',
    factLocation: 'Based in',
    factEducation: 'Education',
    factLanguages: 'Languages',
    educationShort: 'BSc Computer Science',
    languagesValue: 'Hebrew (native) · English (professional)',
    degree: 'BSc Computer Science — GPA 88',
    degreePlace: 'Sapir Academic College',
    highSchool: 'Ort Yad Leibovitz High School, Netanya',
    volunteer1Title: 'Ogen Kehilaty, Beer-Sheva',
    volunteer1Text: 'Supported and taught teenagers at risk.',
    volunteer2Title: 'Soroka Hospital, oncology department',
    volunteer2Text: 'Personal mentor to a child undergoing treatment.',
    militaryTitle: 'Military service — IDF',
    militaryText: 'Tank technician at Mahane Natan, Beer-Sheva.',
};

export default about;
